<div class="relative w-full h-full">
  <canvas
    #moldCanvas
    class="w-full h-full"
    (mousemove)="onCanvasMouseMove($event)"
    (mouseleave)="onCanvasMouseLeave()"
    (mousedown)="onCanvasMouseDown($event)"
    (click)="onCanvasClick($event)"
  ></canvas>

  @if (showDraftAnalysis) {
    <div class="absolute bottom-4 left-4 flex flex-col gap-1 z-10">
      <div class="flex items-center gap-2 text-xs">
        <span
          class="inline-block w-4 h-4 rounded-sm border border-black"
          style="background-color: aqua"
        ></span>
        Visible faces
      </div>
      <div class="flex items-center gap-2 text-xs">
        <span
          class="inline-block w-4 h-4 rounded-sm border border-black"
          style="background-color: red"
        ></span>
        Hidden faces
      </div>
      <div class="flex items-center gap-2 text-xs">
        <span
          class="inline-block w-4 h-4 rounded-sm border border-black"
          style="background-color: yellow"
        ></span>
        Draft faces
      </div>
    </div>
  }

  <div class="flex justify-center gap-2 absolute top-4 w-full">
    <p-button
      icon="pi pi-refresh"
      (click)="doResetView()"
      pTooltip="Reset View"
      tooltipPosition="bottom"
      aria-label="Reset View"
    />
    <p-button
      icon="pi pi-arrow-up-right"
      (click)="toggleAxes()"
      pTooltip="Show Axes"
      tooltipPosition="bottom"
      aria-label="Show Axes"
    />
    <p-button
      icon="pi pi-table"
      (click)="toggleGrid()"
      pTooltip="Show Grid"
      tooltipPosition="bottom"
      aria-label="Show Grid"
    />
    <p-button
      icon="pi pi-circle-off"
      (click)="toggleOpacity(objectGroup)"
      pTooltip="Toggle Opacity"
      tooltipPosition="bottom"
      aria-label="Toggle Opacity"
    />
    @if (hasPlyBlob) {
      <p-button
        icon="pi pi-minus"
        (click)="toggleFaceEdges(objectGroup)"
        pTooltip="Toggle Face Edges"
        tooltipPosition="bottom"
        aria-label="Toggle Face Edges"
      />
    }
    <p-button
      icon="pi pi-pencil"
      (click)="measureTool.toggle()"
      pTooltip="Measure Tool"
      tooltipPosition="bottom"
      aria-label="Measure Tool"
      [label]="measureTool.active ? 'Active' : ''"
    />
  </div>

  @if (measureTool.active && measureTool.distance) {
    <div class="absolute top-16 left-1/2 -translate-x-1/2">
      <p-badge [value]="measureTool.distance + ' mm'" />
    </div>
  }
</div>
